import React, { useEffect, useState } from "react";
import { Reveal } from "./Motion";
import { fileUrl } from "../lib/api";
import { api } from "../lib/api";

const FALLBACK = [
  { image: "https://images.unsplash.com/photo-1647299852821-40401c0b0976?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Garage cleanout — before" },
  { image: "https://images.pexels.com/photos/11802122/pexels-photo-11802122.jpeg?auto=compress&cs=tinysrgb&w=940", caption: "Scrap metal load-out" },
  { image: "https://images.unsplash.com/photo-1670175035057-eec020c03eb9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Curbside haul day" },
  { image: "https://images.unsplash.com/photo-1709831917664-804b57448953?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Attic + storage clear" },
  { image: "https://images.pexels.com/photos/7464687/pexels-photo-7464687.jpeg?auto=compress&cs=tinysrgb&w=940", caption: "Careful hand-carry" },
  { image: "https://images.unsplash.com/photo-1626195863413-ab2978e3cd3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", caption: "Trailer loaded & gone" },
];

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setItems(data.length ? data : FALLBACK)).catch(() => setItems(FALLBACK));
  }, []);

  const list = items.length ? items : FALLBACK;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#050505] py-24 md:py-36 border-t border-[var(--border-dim)]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--accent)]">/ Field Gallery</span>
          <h2 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4 leading-[0.9]">On the job.</h2>
        </Reveal>

        <div className="grid md:grid-cols-12 gap-4">
          {list.map((g, i) => {
            const src = g.image?.startsWith("http") ? g.image : fileUrl(g.image);
            return (
              <Reveal key={g.id || i} delay={(i % 2) * 0.08} className={`${SPANS[i % SPANS.length]} group relative overflow-hidden aspect-[16/10] clip-jag`}>
                <img src={src} alt={g.caption || "Job site"} className="w-full h-full object-cover img-editorial group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                {g.caption && <span className="absolute bottom-4 left-4 font-mono text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">{g.caption}</span>}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
